//选择客户的组件
import React, {useState, useEffect, useRef, useImperativeHandle, forwardRef} from "react"
import ZkSearchGroup from "../../../common/search/zkSearchGroup";
import ZkInput from "../../../common/search/zkInput";
import ZkSelect from "../../../common/search/zkSelect";
import {Checkbox,DatePicker,Pagination} from "antd";
import IconDeleteTag from "../../iconfont/deleteTag/deleteTag";
import moment from "moment";
import ZkLabelSelect from "../../../common/search/zkLabelSelect";
import CloudApi from "../../../cloud/cloud_api";
import Message from "../../../common/message";
import CustomerTag from "../../../cloud/common/customerAndGroupScreening/radioModule/subassembly/customerTag";

const {RangePicker} = DatePicker;
// const defaultCheckedList=[]
const plainOptions = ['Apple'];
const defaultCheckedList = ['Apple', 'Orange'];
const MyCustomer = forwardRef((props,ref)=>{
    const [zkParams,setZkParams]=useState({
        wxid:'',
        chat_wxid:'',
        nickName: '',//客户昵称
        tagFilter:{
            filterType:null,
            tags:[]
        },
        sex:9,//性别
        startTime:null,//起始时间
        endTime:null//截止时间
    })
    const [data,setData]=useState([])//全部数据
    const [selectData,setSelectData]=useState([])//已经选择的数据
    const [checkedList, setCheckedList] = useState(defaultCheckedList);
    const [indeterminate,setIndeterminate]=useState(false)
    const [checkAll, setCheckAll] = useState(false);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [pagInfo, setPagInfo] = useState({
        pageNum:1,
        pageSize:6,
        total:6
    })
    const customerTagRef = useRef(null)
    useEffect(()=>{
        let bodyData=zkParams
        bodyData.wxid=props.wxid
        bodyData.chat_wxid=props.chat_wxid
        setZkParams(bodyData)
        if(data.length==0){
            CloudApi.getChatGetCustomers(6,1,bodyData,(data)=>{
                data.list.forEach((item)=>{
                    item.name=item.nickName
                })
                setData(data.list)
                setPagInfo(data.pagInfo)
            },()=>{
                // Message.error('获取客户列表失败')
            })
        }
    },[props.wxid,props.chat_wxid])

    //每次打开 获取选中的数据
    function getSelectData(list) {
        let newData=[...data]
        if(newData.length>0){
            newData.forEach((item,index)=>{
                item.checked = false
                list.forEach((el)=>{
                    if((el.customerId || el.userId) == item.customerId){
                        item.checked = true
                    }
                })
            })
            setData(newData)
            setSelectData(list)
        }
        if(list.length == 0){
            setCheckAll(false)
        }else {
            let flag = newData.every(item=>item.checked)
            setCheckAll(flag)
        }

        let newZkParams = zkParams
        newZkParams.nickName=''
        newZkParams.tagFilter={
            filterType:null,
            tags:[]
        }
        newZkParams.sex=9
        newZkParams.startTime=null
        newZkParams.endTime=null
        setZkParams(newZkParams)
    }
    //筛选重置
    function query(type,params) {
        let ids= []
        customerTagRef.current.exportTagId() && customerTagRef.current.exportTagId().forEach(item=>{
            ids.push(item.tagId)
        })
        params.tagFilter={
            filterType:customerTagRef.current.exportRadio(),
            tags:ids
        }
        if(!params.sex){params.sex=9}
        params.startTime = startTime
        params.endTime = endTime
        params.wxid=props.wxid
        if(type == 'ok'){
            setZkParams(params)
        }else {
            params={
                wxid:props.wxid,
                chat_wxid:'',
                nickName: '',//客户昵称
                tagFilter:{
                    filterType:null,
                    tags:[]
                },
                sex:9,//性别
                startTime:null,//起始时间
                endTime:null//截止时间
            }
            setZkParams(params)
        }
        CloudApi.getChatGetCustomers(6,1,params,(data)=>{
            data.list.forEach((item)=>{
                item.checked=false
                selectData.forEach((el)=>{
                    if(el.customerId == item.customerId){
                        item.checked = true
                    }
                })
            })
            setData(data.list)
            setPagInfo(data.pagInfo)
        },()=>{
            // Message.error('获取客户列表失败')
        })
        setZkParams(params)
    }
    //全选事件
    function onCheckAllChange (e) {
        let newData=data //获取全部数据
        let hasChecked=selectData
        let arr=[]
        //判断全选按钮为true就把所以数据勾住 为false 就把所有数据抹掉
        e.target.checked ? newData.forEach((item)=>{
            item.checked=true
            if(item.checked){
                let result = hasChecked.findIndex(el => {
                    return el.customerId == item.customerId;
                });
                if(result == -1){
                    hasChecked.push(item)
                }
            }
            setSelectData(hasChecked)//已经勾选住的数据
            }) : newData.forEach((item)=>{
            item.checked=false
            hasChecked.forEach((el)=>{
                if(item.customerId == el.customerId){
                    el.checked=false
                }
            })
            let newSelected=hasChecked.filter(item=>item.checked)
            setSelectData(newSelected)
        })
        setData(newData)
        setIndeterminate(false);
        setCheckAll(e.target.checked);
    }
    //单选事件
    function onChange(customerId) {
        let newSelectData=selectData//获取选中的数据
        let newData=[...data]//获取总的数据
        newData.forEach((item,index)=>{
            if(item.customerId == customerId){
                item.checked=!item.checked
                if(item.checked){
                    newSelectData.push(item)
                    setSelectData(newSelectData)//已经勾选住的数据
                }else {
                    newSelectData=selectData.filter(item=>item.customerId !=customerId)
                    setSelectData(newSelectData)//已经勾选住的数据
                }
            }
        })
        let newCheckedAll=newData.every(item=>item.checked)
        setCheckAll(newCheckedAll);//全选
        let arr=newData.filter(item=>item.checked)
        setIndeterminate(arr.length && arr.length < newData.length);//单选和全选联动的样式
        setData(newData)
    }
    //点击右侧是删除按钮
    function deleteMember(customerId) {
        let newData=[...data]
        newData.forEach((item)=>{
            if(item.customerId == customerId){
                item.checked=false
            }
        })
        let arr=newData.filter(item=>item.checked)
        setIndeterminate(arr.length && arr.length < newData.length);
        setData(newData)
        let newSelectData=selectData.filter(item=>item.customerId!=customerId)
        setSelectData(newSelectData)
        let newCheckedAll=newData.every(item=>item.checked)
        setCheckAll(newCheckedAll);
    }
    //点击清空按钮
    function emptyData() {
        let newData=[...data]
        newData.forEach((item)=>{
            item.checked=false
        })

        let arr=newData.filter(item=>item.checked)
        setData(newData)
        setIndeterminate(arr.length && arr.length < newData.length);

        // let newSelectData=selectData.filter(item=>item.checked)
        setSelectData([])
        setCheckAll(false);
    }
    function dateChange(dates, dateString) {
        setStartTime(dates ? dates[0] : '')
        setEndTime(dates ? dates[1] : '')
    }
    //抛出选中的数据
    function exportData(){
        return selectData
    }

    useImperativeHandle(ref, () => ({
        exportData:exportData,
        getSelectData:getSelectData
    }));
    //新增全选
    // function allChecked() {
    //     CloudApi.getChatGetCustomersSelectAll(zkParams,(arr)=>{
    //         if(arr.list.length > 0){
    //             let newData = data
    //             newData.forEach(item=>{
    //                 item.checked = true
    //             })
    //             arr.list.forEach(el=>{
    //                 el.checked=true
    //             })
    //             let flag = newData.every(item=>item.checked)
    //             setCheckAll(flag)
    //             setData(newData)
    //             setSelectData(arr.list)
    //         }
    //     })
    // }
    return(
        <div className={'my_customer'}>
            <div className={'modification_style'}>
                <ZkSearchGroup
                    onOk={query.bind(this,'ok')}
                    onReset={query.bind(this,'reset')}
                    btnBlock={false}
                >
                    <ZkInput title='客户昵称：' valueKey='nickName' placeholder={'请输入客户昵称'}/>
                    <ZkSelect title={'性别：'} valueKey='sex' placeholder={'请选择性别'}>
                        <Option value={9}>全部</Option>
                        <Option value={0}>未知</Option>
                        <Option value={1}>男</Option>
                        <Option value={2}>女</Option>
                    </ZkSelect>
                    <li style={{marginLeft: '10px'}}>
                        <CustomerTag
                            conWidth={'234px'}
                            titleWidth={'70px'}
                            type={'customer'}
                            ref={customerTagRef}
                            echoData={zkParams.tagFilter}
                            activeState={props.activeState}
                        />
                    </li>
                    <div style={{margin: '0 15px 15px 0'}}>
                        <label>{'添加时间：'}</label>
                        <RangePicker onChange={dateChange} value={startTime && endTime ? [moment(startTime), moment(endTime)] : ''}/>
                    </div>
                </ZkSearchGroup>
            </div>
            <div className={'select_customer'}>
                <div className={'select_customer_left'}>
                    <div style={{justifyContent:'space-between',padding:'0 20px 0 15px'}}>
                        <span>
                            <Checkbox indeterminate={indeterminate} onChange={onCheckAllChange} checked={checkAll}/>
                        <span style={{marginLeft:'10px'}} className={'customer_title'}>客户</span>
                        </span>
                        {/*<span style={{fontWeight: 'bold',cursor:'pointer',color: '#1673FF'}} onClick={allChecked}>全选</span>*/}
                    </div>
                    <ul className={'client_list'}>
                        {
                            data ? <>
                                {
                                    data && data.map((item,index)=>{
                                        return <li key={index}>
                                            <label>
                                                <Checkbox checked={item.checked} disabled={item.isGroupMember == 1 ? true : false} onChange={onChange.bind(this,item.customerId)} />
                                                <img src={item.avatar} style={{width:'36px',border:'1px solid #E8E8E8'}}/>
                                                <div>
                                                    <span>{item.nickName}</span>
                                                    <span className={item.corpName == '微信' ? 'wx_name' : 'qy_name'}>@{item.corpName}</span>
                                                </div>
                                            </label>
                                        </li>
                                    })
                                }
                            </>:'暂无数据'
                        }
                        <div className={'paging_data_set'}>
                            <Pagination pageSize={6} showLessItems={true} simple current={pagInfo.pageNum} total={pagInfo.total}
                                onChange={(pageNum,pageSize)=>{
                                    let bodyData=zkParams
                                    bodyData.wxid=props.wxid
                                    bodyData.chat_wxid=props.chat_wxid
                                    setZkParams(bodyData)
                                    CloudApi.getChatGetCustomers(pageSize,pageNum,bodyData,(data)=>{
                                        data.list.forEach((item,index)=>{
                                            item.checked=false
                                            selectData.forEach((el)=>{
                                                if(el.customerId == item.customerId){
                                                    item.checked = true
                                                }
                                            })
                                        })
                                       let flag=  data.list.every(el =>el.checked)
                                        setCheckAll(flag)
                                        setData(data.list)
                                        setPagInfo(data.pagInfo)
                                    },()=>{
                                        // Message.error('获取客户列表失败')
                                    })
                                }}
                            />
                        </div>
                    </ul>

                </div>
                <div className={'select_customer_right'}>
                    <div>
                        <label>
                            <span className={'customer_title'}>已选客户</span>
                            <span>{selectData ? <>（{selectData.length}）</> : ''}</span>
                        </label>
                        <span className={'empty_data'} onClick={emptyData}>清空</span>
                    </div>
                    <ul className={'right_select_member'}>
                        {
                            selectData && selectData.map((item,index)=>{
                                return <li key={item.customerId}>
                                    <div>
                                        <img src={item.avatar}/>
                                        <div>
                                            <span>{item.nickName || item.name}</span>
                                            <span className={(item.corpName || item.corpshortname) == '微信' ? 'wx_name' : 'qy_name'}>@{item.corpName || item.corpshortname}</span>
                                        </div>
                                    </div>
                                    <label onClick={deleteMember.bind(this,item.customerId)}><IconDeleteTag/></label>
                                </li>
                            })
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
})
export default MyCustomer